import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { Maquina } from '../../types/producao';
import { maquinasService, tiposMaquinaService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<Maquina>[] = [
  { name: 'nome', label: 'Nome', required: true },
  {
    name: 'tipo',
    label: 'Tipo de máquina',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      tiposMaquinaService.list,
      (item: any) => item.descricao ?? item.codigo ?? String(item.id),
    ),
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: [
      { label: 'Ativa', value: 'ATIVA' },
      { label: 'Em manutenção', value: 'MANUTENCAO' },
      { label: 'Parada', value: 'PARADA' },
      { label: 'Inativa', value: 'INATIVA' },
    ],
  },
  { name: 'data_ultima_manutencao', label: 'Última manutenção', type: 'date' },
  { name: 'observacoes', label: 'Observações', type: 'textarea' },
];

export const MaquinasFormPage: React.FC = () => (
  <ResourceFormPage
    title="Nova máquina"
    description="Cadastre uma máquina de produção."
    fields={fields}
    service={maquinasService}
    redirectPath="/admin/producao/maquinas"
    cancelPath="/admin/producao/maquinas"
  />
);
